import { useEffect, useRef } from 'react';
import { matrixService } from '../services/matrixService';
import { useLazyResolveMatrixIdsQuery } from '../store/features/Users/userService';

export const useIdMapLoader = () => {
    const [resolveMatrixIds] = useLazyResolveMatrixIdsQuery();
    const resolveRef = useRef(resolveMatrixIds);
    resolveRef.current = resolveMatrixIds;
    const loadedRef = useRef(false);

    useEffect(() => {
        const tryLoad = () => {
            if (loadedRef.current) return;

            const rooms = matrixService.getRooms();
            const space = rooms.find(room => room.isSpaceRoom()) || null;
            if (!space) return;

            const members = space.getJoinedMembers();
            const matrixIds = members.map(m => m.userId);

            if (matrixIds.length > 0) {
                loadedRef.current = true;
                resolveRef.current({ matrixIds });
                matrixService.off('stateChange', tryLoad);
            }
        };

        tryLoad();

        if (!loadedRef.current) {
            matrixService.on('stateChange', tryLoad);
        }

        return () => {
            matrixService.off('stateChange', tryLoad);
        };
    }, []);
};
